import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    icon: '⚡',
    text: 'Acceso Inmediato'
  }, {
    icon: '📘',
    text: '3 Tomos Principales'
  }, {
    icon: '📗',
    text: '1 Módulo Especializado'
  }, {
    icon: '📚',
    text: '12 Libros Complementarios'
  }, {
    icon: '🎁',
    text: 'Bono Extra con 4 Tomos'
  }];
  return <section className="relative bg-[#1a3622] text-white overflow-hidden pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-124">
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-125">
        <div className="absolute top-[10%] left-1/2 -translate-x-1/2 w-[120%] h-[80%] rounded-full bg-[#2c4c3b]/40 blur-[120px]" data-id="element-126"></div>
        <div className="absolute -bottom-1/4 left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-[#122618]/60 blur-[100px]" data-id="element-127"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-128">
        <div className="max-w-4xl mx-auto text-center mt-[-50px]" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex gap-2 text-[#d4af37] font-bold tracking-wide items-center justify-center mb-6 font-[Merriweather,_serif]" data-id="element-130">
            🌾 MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360™
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-10 text-[#fdfbf7] text-balance text-[18px] font-[Merriweather,_serif]" data-id="element-131">
            Todo tu año de Ciencias Agropecuarias resuelto en una tarde.
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="relative max-w-[320px] sm:max-w-[420px] md:max-w-[540px] lg:max-w-2xl mx-auto mb-10" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/i6TgEGYcNgSe3C8r9wFKJY/seguridad_e_higiene_(3).png" alt="MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.3)] mt-[-20px]" data-id="element-133" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="md:text-xl font-bold text-[#e2e8f0] mb-6 text-balance text-[14px] mt-[-10px] font-[Merriweather,_serif]" data-id="element-134">
            El sistema completo para planificar, enseñar y evaluar educación
            agropecuaria y ganadera — listo para usar desde hoy.
          </motion.p>

          

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-10" data-id="element-135">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-2xl bg-[#d4af37] hover:bg-[#e5c158] text-[#1a3622] font-black uppercase tracking-wide shadow-[0_10px_40px_-10px_rgba(212,175,55,0.4)] hover:shadow-[0_15px_50px_-10px_rgba(212,175,55,0.6)] transition-all hover:-translate-y-1 md:text-base text-[12px]" data-id="element-136">
              🟡 QUIERO MI MEGAPACK AHORA
              <ArrowRight className="w-5 h-5" data-id="element-137" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-[#cbd5e1] font-medium" data-id="element-138">
            <div className="flex items-center gap-1.5" data-id="element-139">
              <Shield className="w-4 h-4 text-[#d4af37]" data-id="element-140" />
              <span data-id="element-141">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-142">
              <Lock className="w-4 h-4 text-[#d4af37]" data-id="element-143" />
              <span data-id="element-144">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-145">
              <CreditCard className="w-4 h-4 text-[#d4af37]" data-id="element-146" />
              <span data-id="element-147">Mercado Pago</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}